const CUSTOM_SCROLLBAR_SELECTOR = '[data-custom-scrollbar]';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomScrollbar, { once: true });
} else {
  initCustomScrollbar();
}

document.addEventListener('shopify:section:load', () => {
  window.requestAnimationFrame(() => document.querySelector(CUSTOM_SCROLLBAR_SELECTOR)?.__kenzScrollbar?.update());
});

function initCustomScrollbar() {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (document.querySelector(CUSTOM_SCROLLBAR_SELECTOR)) return;

  const track = document.createElement('div');
  const thumb = document.createElement('button');

  track.className = 'kenz-custom-scrollbar';
  track.setAttribute('data-custom-scrollbar', '');
  track.setAttribute('aria-hidden', 'true');

  thumb.className = 'kenz-custom-scrollbar__thumb';
  thumb.type = 'button';
  thumb.tabIndex = -1;

  track.appendChild(thumb);
  document.body.appendChild(track);

  let maxScroll = 0;
  let maxThumbY = 0;
  let thumbHeight = 0;
  let isDragging = false;
  let dragStartY = 0;
  let dragStartThumbY = 0;
  let currentThumbY = 0;
  let resizeObserver = null;

  const setThumbY = (y, animated = true) => {
    currentThumbY = Number.isFinite(y) ? Math.min(Math.max(y, 0), maxThumbY) : 0;

    if (window.gsap && animated) {
      window.gsap.to(thumb, { y: currentThumbY, duration: 0.2, ease: 'power2.out', overwrite: true });
      return;
    }

    thumb.style.transform = `translate3d(0, ${currentThumbY}px, 0)`;
  };

  const updateFromScroll = () => {
    const scrollRatio = maxScroll > 0 ? window.scrollY / maxScroll : 0;
    setThumbY(scrollRatio * maxThumbY, !isDragging);
  };

  const update = () => {
    const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    const viewportHeight = window.innerHeight;
    const trackHeight = track.clientHeight;

    maxScroll = Math.max(documentHeight - viewportHeight, 0);
    thumbHeight = maxScroll > 0 ? Math.max((viewportHeight / documentHeight) * trackHeight, 48) : 0;
    maxThumbY = Math.max(trackHeight - thumbHeight, 0);

    track.hidden = maxScroll <= 1;
    thumb.style.height = `${thumbHeight}px`;

    updateFromScroll();
  };

  const scrollFromThumbY = (thumbY) => {
    const ratio = maxThumbY > 0 ? thumbY / maxThumbY : 0;
    window.scrollTo({ top: ratio * maxScroll, behavior: 'auto' });
  };

  const onPointerMove = (event) => {
    if (!isDragging) return;
    const nextY = dragStartThumbY + event.clientY - dragStartY;
    setThumbY(nextY, false);
    scrollFromThumbY(currentThumbY);
  };

  const onPointerUp = () => {
    isDragging = false;
    thumb.releasePointerCapture?.(thumb.__activePointerId);
    delete thumb.__activePointerId;
    document.documentElement.classList.remove('custom-scrollbar-dragging');
  };

  thumb.addEventListener('pointerdown', (event) => {
    if (maxScroll <= 0) return;
    isDragging = true;
    dragStartY = event.clientY;
    dragStartThumbY = currentThumbY;
    thumb.__activePointerId = event.pointerId;
    thumb.setPointerCapture?.(event.pointerId);
    document.documentElement.classList.add('custom-scrollbar-dragging');
    event.preventDefault();
  });

  track.addEventListener('pointerdown', (event) => {
    if (event.target === thumb || maxScroll <= 0) return;
    const rect = track.getBoundingClientRect();
    const targetY = event.clientY - rect.top - thumbHeight / 2;
    setThumbY(targetY, false);
    scrollFromThumbY(currentThumbY);
  });

  window.addEventListener('scroll', updateFromScroll, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);
  window.addEventListener('pointercancel', onPointerUp);

  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(document.body);
  }

  track.__kenzScrollbar = {
    update,
    destroy() {
      resizeObserver?.disconnect();
      window.removeEventListener('scroll', updateFromScroll);
      window.removeEventListener('resize', update);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
      track.remove();
    },
  };

  update();
}
